import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IWorkbookAccelerationInfo } from '../models/IWorkbookAccelerationInfo';
import { Module } from '../Module';
import { GetWorkbookAccelerationsRequest } from '../ServerApi/requests/GetWorkbookAccelerationsRequest';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class WorkbookAccelerations extends Resource<IWorkbookAccelerationInfo> {

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetWorkbookAccelerationsRequest,
      ServerApiMapper.workbookAccelerations));
  }

}

Module.instance().service('WorkbookAccelerations', WorkbookAccelerations);
